import { render } from "./innerheader.vue?vue&type=template&id=2e787088&scoped=true"
import script from "./innerheader.vue?vue&type=script&lang=js"
export * from "./innerheader.vue?vue&type=script&lang=js"

import "./innerheader.vue?vue&type=style&index=0&id=2e787088&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e787088"]])

export default __exports__